module.exports = __webpack_public_path__ + "static/media/mcdonalds.c4550356.png";